import {
  validateAndSubmitPolicaOsiguranja,
  validateAndSubmitIzvjesce,
  validateAndSubmitRaskidUgovora,
  validateAndSubmitRevidirani,
  validateAndSubmitUgovor,
} from "./Evidencije";

export const validateAndSubmitForms = async (
  values,
  selectedRecord,
  cleanup,
  update,
  transitionToUpdate,
  setIdPredPosEvid,
  setShowPotpisivanjeConfirmationModal,
  role,
  fetchEvidencijeTableData
) => {
  // TODO: POSTAVITI VALIDATOR

  switch (selectedRecord) {
    case "1":
      validateAndSubmitPolicaOsiguranja(
        values,
        selectedRecord,
        cleanup,
        update,
        transitionToUpdate,
        setIdPredPosEvid,
        setShowPotpisivanjeConfirmationModal,
        role,
        fetchEvidencijeTableData
      );
      break;
    case "2":
      validateAndSubmitIzvjesce(
        values,
        selectedRecord,
        cleanup,
        update,
        transitionToUpdate,
        setIdPredPosEvid,
        setShowPotpisivanjeConfirmationModal,
        role,
        fetchEvidencijeTableData
      );
      break;
    case "3":
      validateAndSubmitUgovor(
        values,
        selectedRecord,
        cleanup,
        update,
        transitionToUpdate,
        setIdPredPosEvid,
        setShowPotpisivanjeConfirmationModal,
        role,
        fetchEvidencijeTableData
      );

      break;
    case "4":
      validateAndSubmitRaskidUgovora(
        values,
        selectedRecord,
        cleanup,
        update,
        transitionToUpdate,
        setIdPredPosEvid,
        setShowPotpisivanjeConfirmationModal,
        role,
        fetchEvidencijeTableData
      );
      break;
    case "5":
      validateAndSubmitRevidirani(
        values,
        selectedRecord,
        cleanup,
        update,
        transitionToUpdate,
        setIdPredPosEvid,
        setShowPotpisivanjeConfirmationModal,
        role,
        fetchEvidencijeTableData
      );
      break;
  }
};
